var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerminal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m312 255.61c-55.688 0-100.78 45.141-100.78 100.78v480c0 55.688 45.094 100.83 100.78 100.83h576c55.688 0 100.78-45.141 100.78-100.83v-480c0-55.641-45.094-100.78-100.78-100.78zm-187.22 100.78c0-103.36 83.812-187.18 187.22-187.18h576c103.41 0 187.22 83.812 187.22 187.18v480c0 103.41-83.812 187.22-187.22 187.22h-576c-103.41 0-187.22-83.812-187.22-187.22zm758.44 432c0 23.859-19.359 43.219-43.219 43.219h-192c-23.859 0-43.219-19.359-43.219-43.219s19.359-43.172 43.219-43.172h192c23.859 0 43.219 19.312 43.219 43.172zm-444.66-222.52c-16.875-16.875-44.25-16.875-61.125 0s-16.875 44.203 0 61.078l65.484 65.438-65.484 65.484c-16.875 16.875-16.875 44.203 0 61.078s44.25 16.875 61.125 0l96-96c16.875-16.875 16.875-44.203 0-61.078z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminal);
export default __webpack_public_path__ + "static/media/terminal.aac191cd14bd5394b463992178587781.svg";
export { ForwardRef as ReactComponent };